import React from "react";
import { SUPPORT_CHAT_URL } from "app_constants";

const SupportChat = (): React.ReactElement => {
  const chatUrl = `https://${SUPPORT_CHAT_URL}`;

  return (
    <a href={chatUrl} target="_blank" rel="noopener noreferrer">
      {SUPPORT_CHAT_URL}
    </a>
  );
};

export default SupportChat;
